var map = {
	"./radio-off.svg": "xQwY",
	"./radio-on.svg": "okwb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d79I";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/query ^\.\/radio\-.*\.svg$
// module id = d79I
// module chunks = 46